module.exports = __webpack_public_path__ + "img/invoiceVoid.b9ef0492.png";